import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { Subject, takeUntil, tap } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import {
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { DraggableModalWrapperComponent } from '../../../../../shared/components/modal/draggable-modal-wrapper/draggable-modal-wrapper.component';
import { DropdownOption } from '../../../../../core/models/dropdown-option';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { DropdownService } from '../../../../../core/services/resources/dropdown.service';
import { SubmitToFiveDayHoldFormModel } from './models/submit-to-five-day-hold-form-model';
import { SubmitToFiveDayHoldRequest } from '../../models/requests/submit-to-five-day-hold-request';
import { SubmitToFiveDayHoldFormModalData } from './models/submit-to-five-day-hold-form-modal-data';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';

@Component({
    selector: 'app-submit-to-five-day-hold-dialog',
    imports: [
        DraggableModalWrapperComponent,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogActions,
        MatFormFieldModule,
        MatOptionModule,
        MatLabel,
        MatDialogTitle,
        MatDialogContent,
        MatSelectModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './submit-to-five-day-hold-dialog.component.html',
})
export class SubmitToFiveDayHoldDialogComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();

    fiveDayHoldDateOptions: DropdownOption[] = [];

    form: FormGroup<FormGroupType<SubmitToFiveDayHoldFormModel>> =
        this.getFormDefinition();

    constructor(
        private readonly dropdownService: DropdownService,
        private readonly dialogRef: MatDialogRef<SubmitToFiveDayHoldDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private readonly data: SubmitToFiveDayHoldFormModalData,
    ) {}

    ngOnInit(): void {
        this.loadDropdownOptions();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onSave(): void {
        if (this.form.valid) {
            this.data.onSubmit(this.generateRequestObject());
        } else {
            // Show validation errors
            this.form.markAllAsTouched();
        }
    }

    private loadDropdownOptions(): void {
        this.dropdownService
            .getFiveDayHoldDates()
            .pipe(
                takeUntil(this.destroy$),
                tap((options) => (this.fiveDayHoldDateOptions = options)),
            )
            .subscribe();
    }

    private getFormDefinition(): FormGroup<
        FormGroupType<SubmitToFiveDayHoldFormModel>
    > {
        return new FormGroup<FormGroupType<SubmitToFiveDayHoldFormModel>>({
            fiveDayHoldDateId: new FormControl<number | null>(
                null,
                Validators.required,
            ),
        });
    }

    private generateRequestObject(): SubmitToFiveDayHoldRequest {
        return {
            ...this.form.value,
        } as SubmitToFiveDayHoldRequest;
    }
}
